import { Price } from "./Price";
export const PromotionSchemePrice = {
    price,
};
function price(promotionScheme) {
    return Price.total(promotionScheme.activePossiblePromotionInstances.objects.map((promotionInstance) => promotionInstance.value));
}
